import { defineSaleProgress, hasAddress, isSaleCreated, type ProgressSaleData } from '../saleProgress'
import type { Century21Data } from '../scripts/century21Fields'

type LeadCentury21Data = ProgressSaleData & Century21Data

const TIMELINE = 'additionalSales:pulse.timeline.'

const ANSWERS: Array<keyof Century21Data> = [
  'project',
  'alreadyEstimated',
  'alreadyOnMarket',
  'onMarketSince',
  'managedByAgency',
  'agencyName',
  'projectNotes',
  'propertyType',
  'propertyAddress',
  'propertyArea',
  'numberOfRooms',
  'landArea',
  'constructionYear',
  'propertyNotes',
]

export default defineSaleProgress<LeadCentury21Data>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    const isInProgress = hasAddress(data) || !!data.actionsInProgress || ANSWERS.some(field => !!data[field])
    if (isInProgress) return 'progress'

    return 'new'
  },
})
